export default __webpack_public_path__ + "static/media/Starjedi.8d577dc1.ttf";